import { useState } from "react"
import { Button, LoadingSpinner } from "../../components/BaseComponents"
import CanonicalModal from "../../components/BaseComponents/CanonicalModal/CanonicalModal"
import InputCheckbox from "../../components/BaseComponents/InputCheckbox"

type SecrPublishConfirmationProps = {
    companyName: string
    userFullName: string,
    signeeName: string,
    signeeTitle: string,
    open?: boolean;
    onClose: () => void,
    onConfirm: () => void,
    loading?: boolean;
}

function SecrPublishConfirmation({companyName, userFullName, signeeName, signeeTitle, loading, open=false, onClose, onConfirm}: SecrPublishConfirmationProps) {
    const [confirmed, setConfirmed] = useState(false)
    return (
        <CanonicalModal
            open={open}
            onClose={onClose}
            size="small"
            title="Declaration"
            actions={
                loading ? null : (
                    <>
                        <Button requiresWrite disabled={!confirmed} type="Primary" text="Publish" onClick={onConfirm} additionalClass="mr-5" />
                        <Button type="Outlined" text="Cancel" onClick={onClose} />
                    </>
                )
            }
        >
            { loading ? (
                <LoadingSpinner />
            ) : (
                <>
                    <p className="my-2 text-white">
                        I am authorised by { companyName } to publish thiscarbon emissions report. This report may be publicly accessible and made available to other Neoni users.
                    </p>
                    <p className="my-1 text-white">
                        <InputCheckbox
                            checked={confirmed}
                            onChange={e => setConfirmed(e.target.checked) }
                            className="mb-2 mr-2"
                        />
                        {' '}
                        I, {userFullName}, confirm that the information is true and complete to the best of my knowledge and that { signeeName } {signeeTitle && <>({signeeTitle})</>} has approved these accounts for publication.
                    </p>
                </>
            )}
        </CanonicalModal>
    )
}

export default SecrPublishConfirmation;
